import { productDetailsFragment } from '../ProductDetails/fragment.query';
import { lotDetailsFragment } from '../LotDetails/fragment.query';
import { cpscEntityFragment } from '../CpscEntityDetails/fragment.query';

export const cpscFullFragment = `
  fragment cpscFullFields on UsCpscPgaProgram {
    items {
      itemType
      description
      labTestingInfo {
          testDate
      }
      ...productDetailsFields
      ...lotDetailsFields
      manufacturers {
			  ...cpscEntityFields
		  }
		  laboratories {
			  ...cpscEntityFields
		  }
		  certifyingEntities{
			  ...cpscEntityFields
		  }
		  pointOfContacts {
			  ...cpscEntityFields
		  }
    }
  }
  ${productDetailsFragment}
  ${lotDetailsFragment}
  ${cpscEntityFragment}
`;
